import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { grey } from "@mui/material/colors";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import {
  myImage,
  getMyDataJacket,
  getMyDataJacketId,
  getMyDataJacketName,
} from "../../js/queriesHandling";
import { CssDataJacketBodyChip } from "../../styles/styled";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { CssDataJacketBodyTypography } from "../../styles/styled";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import DeleteIcon from "@mui/icons-material/Delete";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import { MydataJacketComfirmModal } from "./mydataJacketComfirmModal";
import { truncateStringWithEllipsis } from "../../js/stringHandling";
import { MydataJacketCardRenameModal } from "./mydataJacketCardRenameModal";
import { MydataJacketCardChangenameModal } from "./mydataJacketCardChangenameModal";
import { Auth, Hub } from "aws-amplify";

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#505458",
      sub: grey[50],
      light: grey[50],
      dark: grey[900],
      constrastText: grey[50],
    },
    secondary: {
      main: "#75787b",
    },
  },
});

const DataJacketCard = styled(Card)`
  ${({ theme }) => `
  cursor: pointer;
  text-align: 'left';
  border-radius: '10px';
  background-color: ${theme.palette.primary.main};
  transition: ${theme.transitions.create(["background-color", "transform"], {
    duration: theme.transitions.duration.standard,
  })};
  // &:hover {
  //   background-color: ${theme.palette.secondary.main};
  //   transform: scale(1.03);
  //   border-color: 'white';
  //   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  // }
  `}
`;

export const MyDataJacketCardComponent = React.forwardRef(
  function MyDataJacketCardComponent(
    { key, jacketId, myDataJacketList, setDeleteData },
    ref
  ) {
    const [image, setImage] = React.useState("");
    const [isTextFieldEnabled, setIsTextFieldEnabled] = React.useState(false);
    const [text, setText] = React.useState("");
    const [openComfirm, setOpenComfirm] = React.useState(false);
    const [openRename, setOpenRename] = React.useState(false);
    const [openChangename, setOpenChangename] = React.useState(false);
    const [flg, setFlag] = React.useState(false);
    const reText = React.useRef(myDataJacketList.data_jacket_name);
    const [invalid, setInvalid] = React.useState("");
    const [user, setUser] = React.useState(null);
    const [newName, setNewName] = React.useState("");

    async function handleButtonClick() {
      if (!isTextFieldEnabled) {
        setIsTextFieldEnabled(true); // ボタンがクリックされたとき、テキストフィールドを有効にする
        const item = await getOneMyDataJacket();
        setText(item.data_jacket_name);
      } else {
      }
    }

    const handleTextChange = (e) => {
      setText(e.target.value);
    };
    async function handleTextBlur() {
      reText.current = text; // 編集が終了したとき、現在のテキストを保存

      const registeredId = await getMyDataJacketId(
        user.username,
        reText.current
      );

      const registeredName = await getMyDataJacketName(user.username);
      const registeredNameArray = registeredName.split(",");
      setNewName(generateUniqueFileName(reText.current, registeredNameArray));
      // 新しい名称を使用して何かしらの処理を実行するなど、必要なロジックを追加する

      if (!isTextFieldEnabled) {
        setIsTextFieldEnabled(true); // ボタンがクリックされたとき、テキストフィールドを有効にする
      } else {
        if (reText.current == "") {
          setInvalid("名称が空白になっています");
        } else if (reText.current.length > 200) {
          setInvalid("名称を200文字以内にしてください");
        } else {
          setIsTextFieldEnabled(false); // ボタンがクリックされたとき、テキストフィールドを無効にする
          setInvalid("");
          if (registeredId) {
            setOpenChangename(true);
          } else {
            setOpenRename(true);
          }
        }
      }
    }

    async function checkUser() {
      try {
        const data = await Auth.currentUserPoolUser();
        const userInfo = { username: data.username, ...data.attributes };
        setUser(userInfo);
        Auth.currentSession().then().catch();
      } catch (err) {}
    }

    // CSV出力機能
    const headers = [
      { label: "データジャケット名", key: "jacketName" },
      { label: "データジャケットの関連業種", key: "jacketIndustry" },
      { label: "データジャケットの概要説明", key: "jacketSummary" },
      {
        label: "データジャケットの収集意図および方法",
        key: "jacketCollection",
      },
      { label: "データジャケットの自由記述", key: "jacketFreeText" },
    ];

    const data = [
      {
        jacketName: myDataJacketList.data_jacket_name,
        jacketSummary: myDataJacketList.data_jacket_summary,
        jacketIndustry: myDataJacketList.data_jacket_industry,
        jacketCollection: myDataJacketList.data_jacket_collection,
        jacketFreeText: myDataJacketList.data_jacket_free_text,
      },
    ];

    const getCurrentTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = ("0" + (now.getMonth() + 1)).slice(-2);
      const day = ("0" + now.getDate()).slice(-2);
      const hour = ("0" + now.getHours()).slice(-2);
      const minute = ("0" + now.getMinutes()).slice(-2);
      const second = ("0" + now.getSeconds()).slice(-2);
      return year + month + day + "_" + hour + minute + second;
    };

    async function handleDownloadCSV() {
      const item = await getOneMyDataJacket();
      data[0].jacketName = item.data_jacket_name;
      const csvData = dataToCSV(data);
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download =
        "MY_DATAJACKET_" +
        item.data_jacket_name +
        "_" +
        getCurrentTime() +
        ".csv";
      a.click();
      URL.revokeObjectURL(url);
    }

    const dataToCSV = (data) => {
      const header =
        headers.map((header) => `"${header.label}"`).join(",") + "\n";
      const rows = data
        .map((row) => headers.map((header) => `"${row[header.key]}"`).join(","))
        .join("\n");
      return "\ufeff" + header + rows; // BOM付きUTF-8
    };

    const handleOpen = () => setOpenComfirm(true);

    async function getOneMyDataJacket() {
      const myDataJacketItem = await getMyDataJacket(
        myDataJacketList.my_data_jacket_id
      );
      return myDataJacketItem;
    }

    const HtmlTooltip = styled(({ className, ...props }) => (
      <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
      [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "white",
        color: "black",
        maxWidth: 220,
      },
    }));

    async function getImage(id) {
      var strImage = await myImage(id);
      setImage({ data: strImage.replace(/\"/g, "") });
    }

    function generateUniqueFileName(fileName, existingFileNames) {
      const regex = /^(.*?)(?:\((\d+)\))?$/;
      const nameMatch = fileName.match(regex);
      const baseName = nameMatch[1]; // ファイル名の基本部分
      const number = parseInt(nameMatch[2], 10) || 1; // 数字の部分を取得、なければ1

      const matchingFiles = existingFileNames.filter((name) =>
        name.toLowerCase().startsWith(baseName.toLowerCase())
      );

      if (matchingFiles.length > 0) {
        let index = number;
        let newFileName = fileName;

        // ファイル名がユニークになるまでインデックスを増やす
        while (existingFileNames.includes(newFileName.toLowerCase())) {
          index++;
          newFileName = `${baseName}(${index})`;
        }

        return newFileName;
      }

      return fileName;
    }

    React.useEffect(() => {
      getImage(jacketId);
      checkUser();
      Hub.listen("auth", (data) => {
        const { payload } = data;
        if (payload.event === "signOut") {
          setUser(null);
        }
      });
    }, []);

    React.useEffect(() => {
      const fetchData = async () => {
        const item = await getOneMyDataJacket();
        const truncatedName = truncateStringWithEllipsis(
          item.data_jacket_name,
          50
        );
        setText(truncatedName);
      };
      fetchData();
    }, [flg]);

    function industryChip() {
      try {
        let result = [];
        let tooltip = [];
        myDataJacketList.data_jacket_industry
          .split(",")
          .map((industry, index) => {
            if (industry !== "" && industry !== undefined) {
              if (index < 6) {
                result.push(
                  <CssDataJacketBodyChip
                    style={{
                      marginTop: "0",
                      marginRight: "0",
                      padding: "-4px -4px -4px -4px",
                      backgroundColor: "#75787B",
                      marginBottom: "4px",
                    }}
                    label={industry}
                  />
                );
              } else {
                tooltip.push(
                  <CssDataJacketBodyTypography style={{ color: "black" }}>
                    {industry}
                  </CssDataJacketBodyTypography>
                );
              }
            }
          });
        if (tooltip.length > 0) {
          result.push(
            <HtmlTooltip title={tooltip}>
              <CssDataJacketBodyChip
                style={{
                  marginTop: "0",
                  marginRight: "0",
                  padding: "-4px -4px -4px -4px",
                  backgroundColor: "#75787B",
                }}
                label={"..."}
              />
            </HtmlTooltip>
          );
        }
        return result;
      } catch {}
    }

    return (
      <Grid xs={2} sm={3} md={3}>
        <ThemeProvider theme={customTheme}>
          <Fade in={true} timeout={1200}>
            <DataJacketCard
              ref={ref}
              style={{
                border: "none",
                display: "flex",
                alignContent: "space-between",
                flexDirection: "column ",
                cursor: "default",
              }}
            >
              <CardContent
                style={{
                  padding: "0",
                  height: "130px",
                }}
              >
                {image.data ? (
                  <img
                    src={`data:image/png;base64,${image.data}`}
                    alt="データジャケット画像"
                    style={{
                      height: "130px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  ""
                )}
              </CardContent>
              <CardContent
                sx={{
                  fontSize: "16px",
                  color: "white",
                  padding: "8px",
                }}
              >
                <FormControl
                  style={{
                    width: "100%",
                    flexDirection: "row ",
                  }}
                >
                  <Button
                    color="primary"
                    onClick={handleButtonClick}
                    style={{
                      padding: 0,
                      minWidth: 0,
                    }}
                  >
                    <ModeEditOutlineOutlinedIcon
                      style={{
                        color: "white",
                      }}
                    />
                  </Button>
                  {isTextFieldEnabled ? (
                    <TextField
                      style={{
                        flex: 1,
                        marginLeft: "15px",
                        backgroundColor: "rgba(255, 255, 255, 0.25)",
                      }}
                      value={text}
                      onChange={handleTextChange}
                      onBlur={handleTextBlur}
                      variant="standard"
                      autoFocus
                      InputProps={{
                        style: {
                          color: "white", // 文字色を白に設定
                          fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                        },
                      }}
                    />
                  ) : (
                    <Typography
                      style={{
                        flex: 1,
                        marginLeft: "10px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        wordBreak: "break-all",
                        fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                      }}
                    >
                      {text}
                    </Typography>
                  )}
                </FormControl>
              </CardContent>
              <Box
                style={{
                  color: "red",
                  padding: "8px",
                  paddingTop: "0px",
                  marginLeft: "35px",
                  marginRight: "35px",
                  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                }}
              >
                {invalid}
              </Box>
              {openRename && (
                <MydataJacketCardRenameModal
                  open={openRename}
                  setOpenRename={setOpenRename}
                  myDataJacketList={myDataJacketList}
                  text={text}
                  reText={reText}
                  flg={flg}
                  setFlag={setFlag}
                  setText={setText}
                />
              )}
              {openChangename && (
                <MydataJacketCardChangenameModal
                  open={openChangename}
                  setOpenChangename={setOpenChangename}
                  myDataJacketList={myDataJacketList}
                  newName={newName}
                  text={text}
                  setFlag={setFlag}
                  flg={flg}
                  setText={setText}
                />
              )}
              <CardContent
                style={{
                  fontSize: "16px",
                  marginLeft: "35px",
                  marginRight: "35px",
                  color: "white",
                  padding: "8px",
                  paddingTop: "0px",
                  wordBreak: "break-all",
                  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                }}
              >
                {myDataJacketList.data_jacket_summary}
              </CardContent>
              <CardContent
                style={{
                  fontSize: "14px",
                  color: "white",
                  padding: "8px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "95%",
                  flexWrap: "wrap",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      textAlign: "left",
                    }}
                  >
                    <AccessTimeIcon />
                    <Typography
                      style={{
                        flex: 1,
                        marginLeft: "12px",
                        fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                      }}
                    >
                      登録日：{myDataJacketList.created_date}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      paddingTop: "5px",
                    }}
                  >
                    <LocalOfferIcon
                      style={{
                        alignItems: "center",
                        paddingTop: "5px",
                        paddingLeft: "2px",
                      }}
                    />
                    <Typography
                      style={{
                        flex: 1,
                        fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                      }}
                    >
                      {industryChip()}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  direction="row"
                  spacing={1}
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    paddingTop: "10px",
                  }}
                >
                  <IconButton
                    sx={{
                      border: "1px solid white",
                      padding: "5px",
                    }}
                  >
                    <DownloadIcon
                      onClick={handleDownloadCSV}
                      sx={{
                        fontSize: 35,
                        color: "white",
                      }}
                    />
                  </IconButton>

                  <IconButton
                    sx={{
                      border: "1px solid white",
                      padding: "5px",
                      marginLeft: "10px",
                    }}
                  >
                    <DeleteIcon
                      onClick={handleOpen}
                      sx={{
                        fontSize: 35,
                        color: "white",
                      }}
                    />
                  </IconButton>
                </Box>
              </CardContent>
              {openComfirm && (
                <MydataJacketComfirmModal
                  open={openComfirm}
                  setOpenComfirm={setOpenComfirm}
                  myDataJacketList={myDataJacketList}
                  setDeleteData={setDeleteData}
                />
              )}
            </DataJacketCard>
          </Fade>
        </ThemeProvider>
      </Grid>
    );
  }
);
